import shared from './shared.styles';

export default (theme: Object) => ({
  ...shared(theme),
});
